import { render, staticRenderFns } from "./top_Backtop.vue?vue&type=template&id=36c4ffb6&scoped=true&"
import script from "./top_Backtop.vue?vue&type=script&lang=js&"
export * from "./top_Backtop.vue?vue&type=script&lang=js&"
import style0 from "./top_Backtop.vue?vue&type=style&index=0&id=36c4ffb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4ffb6",
  null
  
)

export default component.exports